<template>
  <span
    :title="computedStreamStatusTitle"
    :class="['label', 'status', computedStreamStatusClass]"
  >
    {{ computedStreamStatusText }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { getStreamStatusDisplay, getStreamStatusShowProgress, getStreamStatusTitle, getStreamStatusClass } from '@/scripts/shared-video';

const props = defineProps({
  videoFile: {
    type: Object,
    required: false
  }
});

const computedStreamStatusClass = computed(() => {
  if (!props.videoFile) return 'not-uploaded';
  return getStreamStatusClass(props.videoFile.stream_status);
});

const computedStreamStatusText = computed(() => {
  if (!props.videoFile) return 'No File';
  const display = getStreamStatusDisplay(props.videoFile.stream_status);
  const show_progress = getStreamStatusShowProgress(props.videoFile.stream_status);
  if (show_progress && props.videoFile.sg_job_progress !== null) {
    return `${display} ${props.videoFile.sg_job_progress}%`;
  }
  return display;
});

const computedStreamStatusTitle = computed(() => {
  if (!props.videoFile) return 'No video file was uploaded';
  return getStreamStatusTitle(props.videoFile.stream_status);
});

</script>

<style>
@import '@/styles/video-file.css';
</style>
